import { useProject } from "../project";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface Input {
    name?: string;
    description?: string;
    ownerId?: string | null;
}

export function useUpdateDeliverableMutation(workstreamId: string, deliverableId: string) {
    const { project } = useProject();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (input: Input) => {
            await apiClient.updateDeliverable({
                params: { projectId: project.id, workstreamId, deliverableId },
                body: input,
            });
            await queryClient.refetchQueries({ queryKey: ["project", project.id] });
        },
    });
}
